<!-- HM roles list -->
<template>
  <div>
    <span v-if="role.globalAccess">
      <i class="icon-check text-success"></i> Global Access
    </span>
    <span v-else-if="(!role.roles[item] || role.roles[item].length == 0)">
      <i class="icon-exclamation text-danger"></i> No Access
    </span>
    <span v-else-if="role.roles[item].length === roleMap.AccessFullCount">
      <i class="icon-check text-success"></i> Full Access
    </span>
    <span v-else v-for="access in role.roles[item]" :key="access">
      <i class="icon-check text-success"></i>
      {{roleMap.Access[access]}}
      <br>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HMRolesList',
  props: {
    role: {
      type: Object
    },
    item: {
      type: String
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('maps', ['roleMap'])
  }
}
</script>
